import { usePaginatedQuery } from 'react-query';
import { listUsers } from 'src/services/api/users';

function useListUsers(query, enabled = true) {
  return usePaginatedQuery(['users', query], (key, query) => listUsers(query), { enabled });
}

export default useListUsers;
